export default class MarketSettingsModel {
    provider: string | null = null;
}
